import ExpoConstants from 'expo-constants';
import * as Linking from 'expo-linking';
import type { LinkingOptions } from '@react-navigation/native';
import { getStateFromPath } from '@react-navigation/native';
import Constants from 'src/core/utils/Constants';
import { deeplinkHosts } from 'src/core/utils/AppConfig';
import type { RootNavigation } from 'src/presentation/navigation/types/NavigationTypes';

export function resolveDeeplinkPrefixes(): string[] {
	const scheme = ExpoConstants.expoConfig?.scheme;
	const schemes = (Array.isArray(scheme) ? scheme : [scheme]).filter((value): value is string => Boolean(value));
	const hosts: string[] = deeplinkHosts();

	// prettier-ignore
	return [
		Linking.createURL(''),
		...schemes.map((value) => `${value}://`),
		...hosts.map((host) => `https://${host}`),
	];
}

export function rewriteMagicLinkPath(path: string): string {
	const trimmedPath = path.replace(/^\/|\/$/g, '');

	if (!trimmedPath.includes(`${Constants.deeplinkMagicLinkParam}=`)) {
		return trimmedPath;
	}

	const appPath = Constants.deeplinkAppPaths.find((value) => trimmedPath.startsWith(`${value}?`));
	if (!appPath) {
		return trimmedPath;
	}

	return trimmedPath.replace(`${appPath}?`, `${Constants.deeplinkAuthPath}/${Constants.deeplinkLoginPath}?`);
}

const linking: LinkingOptions<RootNavigation> = {
	prefixes: resolveDeeplinkPrefixes(),

	subscribe(listener: (url: string) => void) {
		const linkingSubscription = Linking.addEventListener('url', ({ url }) => {
			listener(url);
		});

		return () => {
			linkingSubscription.remove();
		};
	},

	getStateFromPath: (path: string, options: Parameters<typeof getStateFromPath>[1]) => {
		const resolvedPath = rewriteMagicLinkPath(path);

		return getStateFromPath(resolvedPath, options);
	},

	config: {
		screens: {
			[Constants.navigatorAuth]: {
				path: Constants.deeplinkAuthPath,
				screens: {
					[Constants.screenLogin]: Constants.deeplinkLoginPath,
				},
			},
		},
	},
};

export default linking;
